import { ComponentsVariants, isVariantOf } from '@/components.variants';
import ContentContainer from '@/features/shared/ContentContainer';
import DetailContent from '@/features/shared/DetailContent';
import { MuiContainer, MuiTypography } from '@/features/shared/material-ui';
import AccountMenu from '@/features/shared/portal/AccountMenu';
import PortalTitlePage from '@/features/shared/portal/PortalTitlePage/PortalTitlePage';
import TwoColumnContent from '@/features/shared/TwoColumnContent';
import { animationDuration, ColorNames, SpacingSizes, Theme } from '@/utils/constants';
import { useMediaQuery } from '@material-ui/core';
import { useTheme } from '@material-ui/core/styles';
import clsx from 'clsx';
import React from 'react';
import { Fade } from 'react-reveal';
import { AccountProps } from './Account.interface';
import useAccountStyles from './Account.styles';

const isFormPicker = isVariantOf(ComponentsVariants.FORM_PICKER);
const isPowerApps = isVariantOf(ComponentsVariants.POWER_APPS);

const mapVariantToProps = ({ variant }: any) => {
  if (isFormPicker(variant)) {
    return {
      containerColor: ColorNames.mediumGray,
      enableCRMSSync: true,
    };
  }

  if (isPowerApps(variant)) {
    return {
      showResizeButton: false,
    };
  }
  return {};
};

const mapVariantToClassName =
  (classes: any) =>
  ({ variant, props }: any) => {
    if (isFormPicker(variant)) {
      return classes.detailContentForm;
    }
    return '';
  };

const Account = ({
  pageTitle,
  navigationProps,
  detailContent,
  contentButtons,
  contentTitle,
}: Br.PropsWithContentButtons<AccountProps>) => {
  const classes = useAccountStyles();
  const muiTheme = useTheme();
  const isMobile = useMediaQuery(muiTheme.breakpoints.down('sm'));
  const LeftColumContent = () => (isMobile ? null : <AccountMenu {...navigationProps} />);
  const mainTitle = isMobile ? contentTitle : pageTitle;

  return (
    <div className={classes.root}>
      <ContentContainer
        topSpacing={SpacingSizes.small}
        bottomSpacing={SpacingSizes.medium}
        topBackgroundColor={ColorNames.charcoal}
        bottomBackgroundColor={ColorNames.charcoal}
        className={classes.contentContainer}
      >
        <MuiContainer className="large">
          {contentButtons?.content}
          <Fade duration={animationDuration.primary}>
            <div className={classes.pageHeader}>
              <PortalTitlePage>{mainTitle}</PortalTitlePage>
            </div>
            <div className={classes.pageContent}>
              <TwoColumnContent
                className="content-wrapper"
                columnRatio="25-75"
                leftColumn={<LeftColumContent />}
                rightColumn={
                  <div
                    className={clsx(classes.detailContentCard, 'gntc-account-detail-content-card')}
                  >
                    {!isMobile && (
                      <MuiTypography variant="h6" component="h3" className={classes.contentTitle}>
                        {contentTitle}
                      </MuiTypography>
                    )}
                    <DetailContent
                      content={detailContent}
                      theme={Theme.dark}
                      mapVariantToProps={mapVariantToProps}
                      mapVariantToClassName={mapVariantToClassName(classes)}
                      className={classes.detailContent}
                    />
                  </div>
                }
              />
            </div>
          </Fade>
        </MuiContainer>
      </ContentContainer>
    </div>
  );
};

export default Account;
